export const roadA1 = [
    
    {
        id: 0,
        thumbnail: "https://i.ibb.co/rpNz4py/B2-FIRST-31.png",
         title: "Bienvenida & Diagnóstico",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
            {  titulo:"Presentación del Curso",url: "https://www.youtube.com/watch?v=_1DEJIOcJmY&t=2s"},        

        ],
    },
   
    {
        id: 1,
        thumbnail: "https://i.ibb.co/rpNz4py/B2-FIRST-31.png",

    title: "Fundamentos del idioma",
        subtitle: "Nivel Básico ",
    
        dateAdded: "Basic 0 ",
        channel: "Aprenderemos a presentarnos, deletrear nombres y palabras, describir personas, presentar a la familia y brindar información personal.",
        description: "Aprenderemos Vocabulario básico para poder expresarnos poco a poco en Inglés",
        enlaces: [
            {  titulo:"El alfabeto y pronunciación básica",url4: "https://youtu.be/F1AXA7YfZwY",url: "https://drive.google.com/file/d/1tEYeFBNkhPeYnsTOZ9OwOlqV2G-NRvxQ/view?usp=sharing"},
             {  titulo:"Pronunciación del Alfabeto",url4: "https://youtu.be/S5bkbaIMbGc"},

            {  titulo:"Los pronombres personales", url4: "https://youtu.be/dsrtVjA2NNg",url:"https://drive.google.com/file/d/1Pu56CwPGQgURfEnFkdRJde22DHkFcfLG/view?usp=sharing"},
            {  titulo:"Saludos y Presentaciones",url: "https://drive.google.com/file/d/1Th7-TMO4jmTZ56Fp52eseUo2amrBI8kW/view?usp=sharing",url4: "https://youtu.be/B_cRQMh04w0"},           
            {  titulo:"Los números y las edades ",url: "https://drive.google.com/file/d/1ChYoL8SsS6XY34gBKvnwFEKOOYmJ5Q_w/view?usp=sharing",url4: "https://youtu.be/maDf8azGyX4"},           
            {  titulo:"Artículos a / an", url: "https://drive.google.com/file/d/1sMijpIcGRHYwEH4A-IcIFXh41CyBKW1w/view?usp=sharing",url2: "https://youtu.be/ATCbEl3uHmY"},
            {  titulo:"Los Plurales ",url: "https://drive.google.com/file/d/1zfcj5updmauJsLB7JlfkWcBREUcd_Ixl/view?usp=sharing",url4: "https://youtu.be/KUwH4QwFh7U",url5: "https://wordwall.net/play/75502/816/809"},
            {  titulo:"There is / There are (hay / no hay)",url4:"https://youtu.be/-iZzFm9hPR8",url: "https://wordwall.net/play/19158/687/83046",url5:"https://wordwall.net/play/21498/511/4430"},
            {  titulo:"Preposiciones básicas: in / on / at (lugar/tiempo)",url: "https://drive.google.com/file/d/1V60dUWkmFVUfNccZ3gFnxh6ETv3e5au_/view?usp=sharing",url4: "https://youtu.be/QGoVTlPpYE0"},
            {  titulo:"Números ordinales",url: "https://drive.google.com/file/d/18I58jFyIcYY_apm1YTzXvv2TVuMVHnXk/view?usp=sharing" },

        ],
    },
     {
        id: 2,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",
        title: "El verbo BE (ser/estar)",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [

             {  titulo:"BE en afirmativo",url:"https://drive.google.com/file/d/1I_g6JFWTPoCbcslvyGWqxzlr0jGCoM1H/view?usp=sharing", url4: "https://youtu.be/6KmrJfPuehI",url5:"https://wordwall.net/play/13293/724/51767"},
             {  titulo:"Las Nacionalidades y Profesiones", url: "https://drive.google.com/file/d/1kGKwXpddGXZkPACc9FKruorhp_yfmjSo/view?usp=sharing",url4:"https://youtu.be/1YtqwF1UPbw"},
             {  titulo:"Días de la Semana & Estaciones", url: "https://drive.google.com/file/d/1ufQkzN8VPQEemhepOTymlw9gAfEo0qfI/view?usp=sharing",url3: "https://wordwall.net/play/22419/293/58122",url4:"https://youtu.be/Xr_oUV-_Rzc"},
             {  titulo:" Los colores y Animales",url: "https://drive.google.com/file/d/1N6PIzb8nVmbyMw5ZhGLWoFJZG-nKVeOH/view?usp=sharing" ,url4:"https://youtu.be/AQD3z_-wy0U" },

            {  titulo:"Be Negative & Interrogative",url:"https://drive.google.com/file/d/1fYUiUa-SUpZbIRFSbNjKFtztZqynabMp/view?usp=sharing", url4: "https://youtu.be/3Y6WbRKB29k",url8: "https://wordwall.net/play/1856/077/57902"},
            {  titulo:" Be Wh-questions", url:"https://drive.google.com/file/d/1SOhK3MoMEhEa--7vOtUgYbrBoLMFchjr/view?usp=sharing",url4: "https://youtu.be/VIR927qT0nM"},


              ],
    },
 
    
     {
        id: 3,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",
        title: "Descripción y posesión",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [

            {  titulo:" Familia y partes de la Casa",url: "https://drive.google.com/file/d/112btGBH3SMIBdhZJsdKb-lpNcHuE9JEm/view?usp=sharing",url4:"https://youtu.be/iBWuaXhMWhI" },
            {  titulo:"Possesive Adjectives", url: "https://drive.google.com/file/d/184A1hF7urlyzIWHHm7XRb3dndGAer4ao/view?usp=sharing", url4:"https://youtu.be/IMOxdqYMdEM",url5: "https://wordwall.net/play/55417/749/2837" },
            {  titulo:" Possessive Pronouns",url:"https://drive.google.com/file/d/14Gm5YFjTk--N-2uXY_a985USLG1jBdw7/view?usp=sharing", url4:"https://youtu.be/NIiMdQ8aP40",url5: "https://wordwall.net/play/52592/500/1753"},
            {  titulo:"Los Adjetivos", url: "https://drive.google.com/file/d/12WD9bou7Zqu3cDfm2JDwEPs3D4d6SOjj/view?usp=sharing",url4:"https://youtu.be/JSNG7OanZIg"},
            {  titulo:"Genitivo Sajon & Body Parts", url: "https://drive.google.com/file/d/1zXqo87BkeWyLdIB4eMZJnV3JvXmEgaFL/view?usp=sharing",url4:"https://youtu.be/J6aVbtytpFM"},

              ],
    },
 
      {
        id: 4,
        thumbnail: "https://i.ibb.co/mX3PsJ2/B2-FIRST-28.png",
        title: "Expresiones útiles",
        subtitle: "Centro de Clasificación ",
    
        dateAdded: "Basic 0 ",
        channel: " ",
        description: "Si has llevado clases de inglés antes realiza un examen para calcular tu nivel,Envia tu examen para su corrección al correo temis_it@hotmail.com",
        enlaces: [
                          {  titulo:"Tell the time", url:"https://drive.google.com/file/d/1aMi32PBVfM5T3VWrQbB0Yy3SrKG_KSEW/view?usp=sharing",url4: "https://youtu.be/nfBTafRky5I",url5: "https://wordwall.net/play/11993/400/13264"},
            { titulo: "Imperatives",url: "https://drive.google.com/file/d/1rb6mldX_yloyGxHSw9bTk2p8iQfFVwPm/view?usp=sharing",url4:"https://youtu.be/bqIySFs8r0c",url5:"https://wordwall.net/play/16378/903/4549"},
            {  titulo:" Demonstrative Pronouns & Adjective",url:"https://drive.google.com/file/d/1hnYLBxFqYhSxtvtIC6aTm5WGBaCDv6Eb/view?usp=sharing",url2:"https://drive.google.com/file/d/110FauO9eGqiTbGW-MTVpe4CczVrIQupj/view?usp=sharing", url4: "https://youtu.be/0xolOZ9AaOc"},
            {  titulo:"have got/has got",url:"https://drive.google.com/file/d/1Irqj7eSSPGu61a0U9istdFl1a6aTh9NG/view?usp=sharing",url4:"https://youtu.be/jJgCCREP50I" ,url5: "https://wordwall.net/play/4935/754/2603"},

              ],
    },
 
    
 
    {
        id: 5,
        thumbnail: "https://i.ibb.co/9wVtSxZ/B2-FIRST-18.png",
        title: " Rutinas y presente simple ",
        subtitle: "A1 - Present Progressive Tense",

        dateAdded: "Basic 0 ",
        channel: "sdasd",
        description: "Aprenderemos los concepto elemental en el idiomrir las habilidades necesarias para avanzar a niveles más altos de competencia en el futuro. ",
        enlaces: [
          

            {  titulo:"Present Simple Afirmativo", url:"https://drive.google.com/file/d/1RPry6CTichsaflus2gbVIV3mE4l6mdl4/view?usp=sharing",url4: "https://youtu.be/S3TbSR-TJ3A",url5:"https://wordwall.net/play/57830/431/8032"},
            {  titulo:"Las Frutas y Comidas", url:"https://drive.google.com/file/d/1_gQgAhEJ38c7XLp3qmNqNECjRqORdt73/view?usp=sharing",url4: "https://youtu.be/-T9Au-rGWbY"},
            {  titulo:"Lugares",url: "https://drive.google.com/file/d/11sYrVn0MrbnyEA79IvmqGhBfsgE1EnLk/view?usp=sharing",url4:"https://youtu.be/F8loOzvWhTA" },

            {  titulo:"Object Pronouns ",url: "https://drive.google.com/file/d/1MgV9Cd2rVyOoJ3Bd3_P692S8q-Yaxu9h/view?usp=sharing" ,url4:"https://youtu.be/vW-vTszH4xw",url5: "https://wordwall.net/play/69980/389/917" },
            {  titulo:"Household Objects",url: "https://drive.google.com/file/d/1P-c8iqNpEPg0xqZSy8A_Ydtf9mWVb-2q/view?usp=sharing",url4:"https://youtu.be/BA8hzf7rp-w" },

            {  titulo:"Present Simple Negative & Interrogative ",url:"https://drive.google.com/file/d/1WfymWBrEMkm8gLLvgqGoSvXy83WvlrC_/view?usp=sharing" ,url4: "https://youtu.be/QANvYn5QEUs"},
            { titulo: "Adverbs of Frequency",url: "https://docs.google.com/presentation/d/12feKDZwOqILPrUSp6Nm6vtYqfcgjaQqR/edit?usp=sharing&ouid=114172849724389982127&rtpof=true&sd=true",url4:"https://youtu.be/pkQdCn7qlHc",  url5: "https://wordwall.net/play/54781/327/2832"},
             
            
        ],
    },
  
  

  
    
];
